import { Controller } from "@hotwired/stimulus"

// Handles NHL team search and selection for game forms
export default class extends Controller {
  static targets = ["search", "results", "preview", "logo", "abbrev"]
  
  connect() {
    this.debounceTimer = null
    this.teams = []
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  search() {
    const query = this.searchTarget.value.trim()
    
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.debounceTimer = setTimeout(() => {
      this.fetchTeams(query)
    }, 300)
  }

  async fetchTeams(query) {
    try {
      const response = await fetch(`/admin/nhl/teams?search=${encodeURIComponent(query)}`)
      if (!response.ok) throw new Error('Failed to fetch teams')
      
      this.teams = await response.json()
      this.renderResults()
    } catch (error) {
      console.error('Error fetching NHL teams:', error)
      this.hideResults()
    }
  }

  renderResults() {
    if (this.teams.length === 0) {
      this.hideResults()
      return
    }

    const container = this.resultsTarget.querySelector('div')
    container.innerHTML = this.teams.map(team => `
      <button type="button"
              class="w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-left"
              data-action="click->nhl-team-lookup#selectTeam"
              data-abbrev="${team.abbrev}"
              data-name="${this.escapeAttr(team.name)}"
              data-logo="${this.escapeAttr(team.logo || '')}">
        ${team.logo ? `<img src="${this.escapeAttr(team.logo)}" alt="${this.escapeAttr(team.name)}" class="h-8 w-8 object-contain">` : '<div class="h-8 w-8"></div>'}
        <div>
          <div class="text-sm font-medium text-gray-900 dark:text-white">${this.escapeHtml(team.name)}</div>
          <div class="text-xs text-gray-500 dark:text-gray-400">${team.abbrev}</div>
        </div>
      </button>
    `).join('')

    this.resultsTarget.classList.remove('hidden')
  }

  selectTeam(event) {
    event.preventDefault()
    const button = event.currentTarget
    const abbrev = button.dataset.abbrev
    const name = button.dataset.name
    const logo = button.dataset.logo

    // Update the search field with team name
    this.searchTarget.value = name

    // Store the abbreviation in hidden field
    this.abbrevTarget.value = abbrev

    // Show logo preview
    if (logo) {
      this.logoTarget.src = logo
      this.previewTarget.classList.remove('hidden')
    }

    this.hideResults()
  }

  hideResults() {
    this.resultsTarget.classList.add('hidden')
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text || ''
    return div.innerHTML
  }

  escapeAttr(text) {
    return (text || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
  }
}
